import React, { Component } from 'react';
import SelectorModel from "./SelectorModel";

export default class SelectorEdit extends Component {

    state = {
        model: new SelectorModel({
            pointerEvents: 'none',
            borderWidth: 3,
            borderColor: "rgb(76, 202, 44)",
            borderStyle: "dashed",
        })
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {

    }

    componentWillUnmount() {

    }

    render() {

        return (
            <div className={"selector-ui selector-edit"} style={this.state.model.toStyle()}>
            </div>
        );
    }
}
